import { Toaster } from '@grupoboticario/flora-react'

const triggerToastError = (message, callback = () => {}, withTimeout = false) => {
  Toaster.notify({
    kind: 'error',
    description: message
  })
  if (withTimeout) setTimeout(() => callback(), 1000)
  else callback()
}

export default triggerToastError
